export const getPosition = (event) => {
  if ('touches' in event) {
    const { pageX, pageY } = event.touches[0]
    return { x: pageX, y: pageY }
  }

  const { screenX, screenY } = event
  return { x: screenX, y: screenY }
}

export const fixTransform = (zoom, selector) => {
  if (!zoom || !selector || !document.querySelectorAll(selector)[1]) {
    return
  }
  const zoomOptions = zoom.getOptions()
  const active = {
    zoomed: zoom.getZoomedImage(),
    zoomedHd: document.querySelectorAll(selector)[1]
  }
  active.zoomedHd.classList.add('zoomedhd')
  let container = {
    width: window.innerWidth,
    height: window.innerHeight,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  }
  let viewportWidth
  let viewportHeight

  if (zoomOptions.container) {
    if (zoomOptions.container instanceof Object) {
      // The container is given as an object with properties like width, height, left, top
      container = {
        ...container,
        ...zoomOptions.container
      }

      // We need to adjust custom options like container.right or container.bottom
      viewportWidth =
        container.width -
        container.left -
        container.right -
        zoomOptions.margin * 2
      viewportHeight =
        container.height -
        container.top -
        container.bottom -
        zoomOptions.margin * 2
    } else {
      // The container is given as an element
      const zoomContainer = document.querySelector(zoomOptions.container)

      const {
        width,
        height,
        left,
        top
      } = zoomContainer.getBoundingClientRect()

      container = {
        ...container,
        width,
        height,
        left,
        top
      }
    }
  }

  viewportWidth = viewportWidth || container.width - zoomOptions.margin * 2
  viewportHeight =
    viewportHeight || container.height - zoomOptions.margin * 2

  const zoomTarget = active.zoomedHd
  const naturalWidth = zoomTarget.naturalWidth || viewportWidth
  const naturalHeight = zoomTarget.naturalHeight || viewportHeight

  const boundingClient = active.zoomed.getBoundingClientRect()
  const { top, left } = boundingClient
  let width = boundingClient.width
  let height = boundingClient.height
  if (zoomTarget.dataset && zoomTarget.dataset.highresWidth !== undefined &&
    zoomTarget.dataset.highresHeight !== undefined) {
    width = zoomTarget.dataset.highresWidth
    height = zoomTarget.dataset.highresHeight
  }
  const scaleX = Math.min(naturalWidth, viewportWidth) / width
  const scaleY = Math.min(naturalHeight, viewportHeight) / height
  const scale = Math.min(scaleX, scaleY)
  const translateX =
    (-left +
      (viewportWidth - width) / 2 +
      zoomOptions.margin +
      container.left) /
    scale
  const translateY =
    (-top +
      (viewportHeight - height) / 2 +
      zoomOptions.margin +
      container.top) /
    scale
  const transform = `scale(${scale}) translate3d(${translateX}px, ${translateY}px, 0)`

  active.zoomedHd.style.opacity = 1
  active.zoomedHd.style.width = `${width}px`
  active.zoomedHd.style.height = `${height}px`
  active.zoomedHd.style.transform = transform
}
